import MiddlewareFacade from './MiddlewareFacade';

/**
 * A factory function forming a simplified, primary consumer entry
 * point into the player middleware.
 */

const middlewareFactory = (parentElement, options = {}) => {
    const middleware = new MiddlewareFacade(parentElement, options);

    return middleware;
};

export default middlewareFactory;
